export const RATING_FROM = 0
export const RATING_TO = 5

export const inRange = (num) => {
    return num < RATING_FROM ? RATING_FROM : (num > RATING_TO ? RATING_TO : num)
}